import SubscriptionUpdatePaymentModal from './SubscriptionUpdatePaymentModal';

export default SubscriptionUpdatePaymentModal;
